import { Component, Input, OnInit } from '@angular/core';
import {
  AlertService,
  ComponentsStoreService,
  FileStoreService,
  IAlertType
} from '../../../../_shared/services';
import { Components, Files } from '../../../../_shared/interfaces';
import { saveAs } from 'file-saver';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule } from "@clr/angular";
import { environment as env } from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import { TranslocoDirective } from "@jsverse/transloco";
import { DatePipe, NgIf } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../../core/upload/upload.component";
import {
  ClarityIcons,
  timesCircleIcon
} from "@cds/core/icon";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';
@Component({
  selector: 'app-job-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    TranslocoDirective,
    NgIf,
    DatePipe,
    ClrIconModule,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    UploadComponent
  ],
  templateUrl: './job-details-documents.component.html',
  styleUrl: './job-details-documents.component.sass'
})

export class JobDetailsDocumentsComponent implements OnInit {
  components: Components[] = [];
  jobsFiles: Files[] = [];
  public showPdf = false;
  public showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  private filesDirectory = filesBaseUrl();

  @Input() jobId: number = 0;
  @Input() projectId: string = '';

  constructor(
    private componentsService: ComponentsStoreService,
    private fileService: FileStoreService,
    private alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([3,4,5,6,7,8,20,40,51,55,60,61,80,98], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([3,4,5,6,7,8,20,40,51,55,60,61,80,98], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectID: string) {
    this.fileService.getFilesSet(docType, projectID, this.jobId, 0).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.jobsFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.jobsFiles = data.object;
      },
      complete: () => {
        this.loading = false;
        },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.jobsFiles = this.jobsFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([3,4,5,6,7,8,20,40,51,55,60,61,80,98], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
